module.exports = __webpack_public_path__ + "img/switch.cb4d4183.png";